/* eslint-disable @typescript-eslint/no-explicit-any */
import { QueryKey, UseQueryOptions, useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import Core, { API_V2 } from '../../core';
import { useAppSelector } from '../../../infra/hooks';

export const useList = (
  url: string,
  params?: object,
  config?:
    | Omit<UseQueryOptions<any, unknown, any, object[]>, 'queryKey' | 'queryFn'>
    | undefined,
  apiVersion = API_V2,
) => {
  let _params = {};
  const companyId = useAppSelector((state) => state?.authSlice?.company_id);
  const [search] = useSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value)
        _params = {
          ..._params,
          [key]: value,
        };
    });
  }

  _params = {
    ..._params,
    page: search?.get('page') ? parseInt(search.get('page') || '1') + 1 : 1,
    companyId,
    locale: localStorage.getItem('emplang'),
  };

  const context = useQuery(
    [url, _params],
    ({ queryKey }) => fetcher({ queryKey, apiVersion }),
    {
      enabled:
        config?.enabled !== undefined ? (url ? true : false) : config?.enabled,
      ...config,
    },
  );

  return context;
};

export const fetcher = async ({
  queryKey,
  apiVersion,
}: {
  queryKey: QueryKey;
  apiVersion: string;
}) => {
  const api = Core.getInstance().api();

  try {
    const [url, params] = queryKey;
    return await api.get(`${apiVersion}/${url}`, {
      params: { ...(params as object) },
    });
  } catch (error) {
    return null;
  }
};
